import React, { useState, useEffect } from "react";
import axios from "axios";
import { API_URL } from "app/config";
import { store } from "app/store";
import {
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Paper,
  Typography,
  CircularProgress,
  Grid,
  Box,
  Card,
  CardContent,
} from "@mui/material";
import StateWiseMatrixChart from "./StateWiseMatrixChart";
import InsuranceClaimsStateWise from "./InsuranceClaimsStateWise";
const InsuranceClaimCharts = ({activeButton}) => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [selectedState, setSelectedState] = useState(null);
  const [selectedDistrict, setSelectedDistrict] = useState(null);
  const state = store.getState();
  const getPayload = () => {
    let groupBy = ["state_name"];
    if (selectedDistrict) {
      groupBy = ["state_name", "district_name", "block_name"];
    } else if (selectedState) {
      groupBy = ["state_name", "district_name"];
    }
    return {
      service_name: "Insurance",
      product_name: "Cattle_Claims",
      group_by: groupBy,
    };
  };

  useEffect(() => {
    fetchData();
  }, [selectedState, selectedDistrict,activeButton]);

  const fetchData = async () => {
    setLoading(true);
    setError(null);
    try {
      const response = await axios.patch(
        `${API_URL}/mis/api/v1/analytics`,
        getPayload(),
        {
          headers: { authorization: `Bearer ${state.auth.accessToken}` },
        }
      );
      setData(response.data.data);
    } catch (err) {
      setError(err.message || "Something went wrong!");
    } finally {
      setLoading(false);
    }
  };

  const filteredDataEmpty = data?.group_by_count?.filter(
    (row) =>
      (selectedDistrict
        ? row.block_name
        : selectedState
        ? row.district_name
        : row.state_name) !== ""
  );

  const filteredData = (filteredDataEmpty || [])
  .filter((row) => {
    if (selectedDistrict) {
      return (
        row.state_name === selectedState &&
        row.district_name === selectedDistrict
      );
    }
    if (selectedState) {
      return row.state_name === selectedState;
    }
    return true;
  })
  .sort((a, b) => (b.total_count || 0) - (a.total_count || 0)); 


 
  const claimMetrics = [
  {
    label: "Leads Generated",
    key: "lead_generated",
    icon: (
      <span
        className="mdi mdi-account-multiple-outline"
        style={{ color: "#1976D2", fontSize: 30 }}
      />
    ),
  },
  {
    label: "Claims Accepted",
    key: "claim_accepted",
    icon: (
      <span
        className="mdi mdi-check-circle-outline"
        style={{ color: "#2E7D32", fontSize: 30 }}
      />
    ),
  },
   {
    label: "Claims Declined",
    key: "claim_declined",
    icon: (
      <span
        className="mdi mdi-close-circle-outline"
        style={{ color: "#F57C00", fontSize: 30 }}
      />
    ),
  },
  {
    label: "Claims Approved",
    key: "claim_approved",
    icon: (
      <span
        className="mdi mdi-shield-check-outline"
        style={{ color: "#388E3C", fontSize: 30 }}
      />
    ),
  },
 
  {
    label: "Claims Rejected",
    key: "claim_rejected",
    icon: (
      <span
        className="mdi mdi-cancel"
        style={{ color: "#D32F2F", fontSize: 30 }}
      />
    ),
  },
  {
    label: "Claims Settled",
    key: "claim_settled",
    icon: (
      <span
        className="mdi mdi-cash-check"
        style={{ color: "#6A1B9A", fontSize: 30 }}
      />
    ),
  },
];

  return (
    <Box sx={{ width: "100%", borderRadius: 2, padding: 1 }}>
    
      <div>
        <Typography variant="h5" align="center" sx={{ color: "#333" }}>
          Overall Metrics
        </Typography>
      <Grid container spacing={2}>
  {claimMetrics.map((item, index) => (
    <Grid item xs={12} sm={6} md={4} lg={2} key={index}>
      <Card
        sx={{
          borderRadius: 2,
          border: "1px solid #eee",
          boxShadow: "0 1px 4px rgba(0,0,0,0.06)",
          p: 1.5,
          textAlign: "center",
          height: "100%",
        }}
      >
        <Box mb={0.5}>{item.icon}</Box>

        <Typography
          variant="h5"
          sx={{ fontWeight: 600, color: "#222" }}
        >
          {data?.status_wise_count?.[item.key] ?? 0}
        </Typography>

        <Typography
          variant="caption"
          sx={{ color: "#666", fontWeight: 500 }}
        >
          {item.label}
        </Typography>
      </Card>
    </Grid>
  ))}
</Grid>


      </div>
      <Grid container spacing={2} className="mt-1">
        <Grid item xs={12} md={12}>
          <TableContainer
            component={Paper}
            sx={{
              overflowY: "scroll",
              backgroundColor: "#fff",
              boxShadow: 1,
              borderRadius: 1,
            }}
          >
            <div className="position-relative mx-3">
              <Typography
                variant="h5"
                align="center"
                sx={{ marginTop: 3, color: "#333" }}
              >
                State-wise Metrics
              </Typography>

              <div
                style={{
                  position: "absolute",
                  right: 0,
                  top: "50%",
                  transform: "translateY(-50%)",
                  display: "flex",
                  alignItems: "center",
                  gap: "8px",
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  maxWidth: "60%", 
                }}
              >
                {selectedState && !selectedDistrict && (
                  <Typography
                    sx={{
                      cursor: "pointer",
                      color: "primary.main",
                      fontWeight: "bold",
                      "&:hover": { textDecoration: "underline" },
                    }}
                    onClick={() => setSelectedState(null)}
                  >
                    ← State ({selectedState})
                  </Typography>
                )}

                {selectedDistrict && (
                  <>
                    <Typography
                      sx={{
                        cursor: "pointer",
                        color: "primary.main",
                        fontWeight: "bold",
                        "&:hover": { textDecoration: "underline" },
                      }}
                      onClick={() => {
                        setSelectedState(null);
                        setSelectedDistrict(null);
                      }}
                    >
                      ← {selectedState}
                    </Typography>

                    <Typography
                      sx={{
                        cursor: "pointer",
                        color: "primary.main",
                        fontWeight: "bold",
                        mx: 1,
                        "&:hover": { textDecoration: "underline" },
                      }}
                      onClick={() => setSelectedDistrict(null)}
                    >
                      / {selectedDistrict}
                    </Typography>
                  </>
                )}
              </div>
            </div>

            {loading ? (
              <CircularProgress
                sx={{ display: "block", margin: "20px auto" }}
              />
            ) : error ? (
              <Typography color="error" align="center" sx={{ marginTop: 2 }}>
                {error}
              </Typography>
            ) : (
           <Table className="mt-3">
  <TableHead>
    <TableRow
      sx={{
        background: "linear-gradient(to right, #6A1B9A, #8E24AA)",
      }}
    >
      {!selectedDistrict && !selectedState && (
        <TableCell sx={{ fontWeight: "bold" }}>
          State Name
        </TableCell>
      )}

      {selectedState && !selectedDistrict && (
        <TableCell sx={{ fontWeight: "bold" }}>
          District Name
        </TableCell>
      )}

      {selectedDistrict && (
        <TableCell sx={{ fontWeight: "bold" }}>
          Block Name
        </TableCell>
      )}

      <TableCell sx={{ fontWeight: "bold" }}>
        Lead Generated
      </TableCell>
      <TableCell sx={{ fontWeight: "bold" }}>
        Claims Accepted
      </TableCell>
       <TableCell sx={{ fontWeight: "bold" }}>
        Claims Declined
      </TableCell>
      <TableCell sx={{ fontWeight: "bold" }}>
        Claims Approved
      </TableCell>
     
      <TableCell sx={{ fontWeight: "bold" }}>
        Claims Rejected
      </TableCell>
      <TableCell sx={{ fontWeight: "bold" }}>
        Claims Settled
      </TableCell>
    </TableRow>
  </TableHead>

  <TableBody>
    {filteredData?.map((row, index) => (
      <TableRow
        key={index}
        sx={{
          cursor: "pointer",
          "&:nth-of-type(even)": { backgroundColor: "#fafafa" },
          "&:hover": { backgroundColor: "#f3e5f5" },
        }}
      >
        {!selectedDistrict && !selectedState && (
          <TableCell
            sx={{
              color: "#6A1B9A",
              fontWeight: 500,
              cursor: "pointer",
              "&:hover": { textDecoration: "underline" },
            }}
            onClick={() => setSelectedState(row.state_name)}
          >
            {row.state_name || "-"}
          </TableCell>
        )}

        {selectedState && !selectedDistrict && (
          <TableCell
            sx={{
              color: "#7B1FA2",
              cursor: "pointer",
              "&:hover": { textDecoration: "underline" },
            }}
            onClick={() => setSelectedDistrict(row.district_name)}
          >
            {row.district_name || "-"}
          </TableCell>
        )}

        {selectedDistrict && (
          <TableCell>{row.block_name || "-"}</TableCell>
        )}

        <TableCell sx={{ fontWeight: 600, color: "#1976D2" }}>
          {row.lead_generated ?? 0}
        </TableCell>

        <TableCell sx={{ fontWeight: 600, color: "#2E7D32" }}>
          {row.claim_accepted ?? 0}
        </TableCell>
          <TableCell sx={{ fontWeight: 600, color: "#F57C00" }}>
          {row.claim_declined ?? 0}
        </TableCell>

        <TableCell sx={{ fontWeight: 600, color: "#388E3C" }}>
          {row.claim_approved ?? 0}
        </TableCell>

      

        <TableCell sx={{ fontWeight: 600, color: "#D32F2F" }}>
          {row.claim_rejected ?? 0}
        </TableCell>

        <TableCell sx={{ fontWeight: 600, color: "#6A1B9A" }}>
          {row.claim_settled ?? 0}
        </TableCell>
      </TableRow>
    ))}
  </TableBody>
</Table>

            )}
          </TableContainer>
        </Grid>
      </Grid>
      <Grid container spacing={2} className="mt-2">
        <Grid item xs={12} md={12}>
          <Card
            sx={{
              borderRadius: 1,
              mb: 2,
              bgcolor: "#ffffff",
              boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)", // Subtle shadow
              p: 1,
            }}
          >
            <Typography
              variant="h5"
              align="center"
              sx={{ marginTop: 1, color: "#333", marginBottom: 2 }}
            >
              Analytics State-wise Metrics
            </Typography>
            <CardContent sx={{ p: 0, "&:last-child": { paddingBottom: 0 } }}>
              <InsuranceClaimsStateWise
                filteredData={filteredData}
                selectedState={selectedState}
                selectedDistrict={selectedDistrict}
              />
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    </Box>
  );
};

export default InsuranceClaimCharts;
